import {useMutation, useQueryClient} from "@tanstack/react-query";
import {assignPortfolioToAdminUrl, gradeCourseUrl} from "../../constants/api/endpoints";
import {useAxios} from "../../hooks/axios/useAxios";
import {toast} from "react-toastify";

export const useGradeCourse = () => {
  const queryClient = useQueryClient();
  const axios = useAxios();

  async function postGrade(data: {grade: string, course_recommendation_id: string, approved: boolean}) {
    return axios.post(gradeCourseUrl, data)
  }

  return useMutation({
    mutationKey: ['grade-course'],
    mutationFn: postGrade,
    onSuccess: () => {
      queryClient.invalidateQueries({queryKey: ['evidences']})
      toast.success('Feedback submitted!');
    }
  });
}